import React from "react"

const DownloadPDF = (blobData, fileName) => {
  const url = window.URL.createObjectURL(new Blob([blobData]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${fileName}.pdf`); // Remove curly braces and add .pdf extension
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
export default DownloadPDF

// import jsPDF from "jspdf"
// import "jspdf-autotable"

// const DownloadPDF = (docTitle, tableHead, tableBody, fontSize) => {
//   const doc = new jsPDF()
//   doc.text(docTitle, 14, 16)

//   if (tableBody && tableBody.length > 0) {
//     doc.autoTable({
//       head: [tableHead],
//       body: tableBody,
//       startY: 25,
//       styles: { fontSize: fontSize || 8 }, // Default font size is 8 if not provided
//     })
//   }

//   doc.save(`${docTitle}.pdf`)
// }

// export default DownloadPDF
